/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Provider_DetailInputs */

const en_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted processing in the EU. No API key required. For current provider and region details, see /privacy.`)
};

const de_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestuetzte Verarbeitung in der EU. Kein API-Schluessel erforderlich. Aktuelle Anbieter- und Regionsdetails unter /privacy.`)
};

const fr_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement IA en UE. Aucune clé API requise. Pour les détails actuels sur le fournisseur et la région, voir /privacy.`)
};

const es_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesamiento de IA en la UE. No se requiere clave API. Para detalles actuales de proveedor y región, ver /privacy.`)
};

const it_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione IA nell'UE. Nessuna chiave API richiesta. Per i dettagli attuali su fornitore e regione, vedere /privacy.`)
};

const nl_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-verwerking in de EU. Geen API-sleutel vereist. Voor actuele details over aanbieder en regio, zie /privacy.`)
};

const pl_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie AI w UE. Klucz API nie jest wymagany. Aktualne informacje o dostawcy i regionie: /privacy.`)
};

const fi_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoalykasittely EU:ssa. API-avainta ei tarvita. Ajantasaiset tiedot palveluntarjoajasta ja alueesta: /privacy.`)
};

const da_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-behandling i EU. Ingen API-nøgle krævet. For aktuelle oplysninger om udbyder og region, se /privacy.`)
};

const sv_settings_ai_provider_detail = /** @type {(inputs: Settings_Ai_Provider_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-behandling i EU. Ingen API-nyckel kravs. For aktuell information om leverantor och region, se /privacy.`)
};

/**
* | output |
* | --- |
* | "AI-assisted processing in the EU. No API key required. For current provider and region details, see /privacy." |
*
* @param {Settings_Ai_Provider_DetailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_provider_detail = /** @type {((inputs?: Settings_Ai_Provider_DetailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Provider_DetailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_provider_detail(inputs)
	if (locale === "fr") return fr_settings_ai_provider_detail(inputs)
	if (locale === "es") return es_settings_ai_provider_detail(inputs)
	if (locale === "it") return it_settings_ai_provider_detail(inputs)
	if (locale === "nl") return nl_settings_ai_provider_detail(inputs)
	if (locale === "pl") return pl_settings_ai_provider_detail(inputs)
	if (locale === "fi") return fi_settings_ai_provider_detail(inputs)
	if (locale === "da") return da_settings_ai_provider_detail(inputs)
	if (locale === "sv") return sv_settings_ai_provider_detail(inputs)
	return en_settings_ai_provider_detail(inputs)
});